<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{mode}}] {{$t('user')}}
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true" aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel" style="width: 550px" :breakpoints="{'960px': '80vw'}">
                                <div class="p-grid p-field">
                                    <div class="p-row">
                                        <i class="pi pi-plus-circle" /> {{this.$formatDateTime(header.Create_Date)}} 
                                    </div>
                                    <div class="p-row">
                                        by {{header.Create_By}}
                                    </div>
                                </div>
                                <div class="p-grid p-field" v-if="header.Edit_Date">
                                    <div class="p-row">
                                        <i class="pi pi-pencil" /> {{this.$formatDateTime(header.Edit_Date)}} 
                                    </div>
                                    <div class="p-row">
                                        by {{header.Edit_By}}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <!-- <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="canSave && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status != this.$APPROVAL_STATUS.APPROVED && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_REVISION)"/> -->
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="canSave && mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                        v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <TabView>
                        <TabPanel header="Header Groups">
                            <!-- <div v-if="header && isOverNotAccess">
                                <Message severity="warn" :closable="false">
                                    {{ $t('inactive_account') }} ({{ Is_Locked ? 'Locked' : 'Unlocked'}})
                                </Message>
                            </div> -->
                            <div class="grid">
                                <div class="col-6">

                                    <FormField :labelName="$t('user_type')" fieldName="User_Type" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <CustomSelect 
                                            class="p-inputtext-sm" 
                                            v-model="header.User_Type" 
                                            :url="this.$API_URL + 'list/lookup'" 
                                            :minLength="0" 
                                            :params="{ group : 'USER_TYPE'}" 
                                            v-if="header" 
                                            :disabled="mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || (header && header.Status == this.$APPROVAL_STATUS.APPROVED)"
                                            :filter="true"
                                            @change="onChangeUserType($event)"
                                            />
                                            <small
                                            v-if="header && !header.User_Type && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('user_type')) }}
                                        </small>
                                    </FormField>

                                    <FormField :labelName="$t('emp_number')" fieldName="Employee_Number" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Employee_Number" v-model="header.Employee_Number" type="text" :placeholder="$t('emp_number')" 
                                        v-if="header" :disabled="!canEdit || (header && header.Status == this.$APPROVAL_STATUS.APPROVED) || (header && (header.User_Type == this.$USER_LEVEL.CONTRACTOR || header.User_Type == this.$USER_LEVEL.OUTSOURCING))" v-on:blur="onBlur()"/>
                                        <small
                                            v-if="header && !header.Employee_Number && submitted && mode != this.$FORM_MODE_DELETE && header.User_Type != this.$USER_LEVEL.CONTRACTOR && header.User_Type != this.$USER_LEVEL.OUTSOURCING"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('emp_number')) }}
                                        </small>
                                    </FormField>

                                    <FormField :labelName="$t('full_name')" fieldName="Full_Name" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Full_Name" v-model="header.Full_Name" type="text" :placeholder="$t('full_name')"  v-if="header" :disabled="!canEdit"  :upper="true"/>
                                        <small
                                            v-if="header && !header.Full_Name && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('full_name')) }}
                                        </small>
                                    </FormField>

                                    <FormField :labelName="$t('email')" fieldName="Email" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Email" v-model="header.Email" type="text" :placeholder="$t('email')"  v-if="header" :disabled="!canEdit" :upper="true"/>
                                        <small
                                            v-if="(header && !header.Email && submitted && mode != this.$FORM_MODE_DELETE)"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('email')) }}
                                        </small>
                                        <small v-if="(header && header.Email && validateEmail())"  class="p-error">{{ $t('format_email')}}
                                            
                                        </small>
                                    </FormField>

                                    <!-- <FormField :labelName="$t('location')" fieldName="Location_Code" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header">
                                        <CustomSelect 
                                            class="p-inputtext-sm" 
                                            v-model="header.Location_Code" 
                                            :url="this.$API_URL + 'list/location_code'" 
                                            :minLength="0" 
                                            :params="{isAuth : true}" 
                                            v-if="header" 
                                            :disabled="mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || (header && header.Status == this.$APPROVAL_STATUS.APPROVED) || this.hidelocation"
                                            :filter="true"
                                            />
                                        <small v-if="header && !header.Location_Code && submitted && mode != this.$FORM_MODE_DELETE && header.Location_All == false"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('location')) }}
                                        </small>
                                    </FormField> -->

                                    <FormField :labelName="$t('department')" fieldName="Department" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <CustomSelect  v-if="header" name="Department" 
                                            v-model="header.Department_Code"  
                                            :url="$API_URL + 'list/lookup'"
                                            :params="{ group: $LOOKUP_GROUP.DEPARTMENT }" 
                                            :minLength="0" 
                                            :filter="true"
                                            :placeholder="$t('department')"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                        <small v-if="header && !header.Department_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('department')) }}
                                        </small>
                                    </FormField>

                                    <!-- <FormField :labelName="$t('location')" fieldName="Location_Code" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <CustomSelect class="p-inputtext-sm" v-model="header.Location_Code" v-if="header"
                                        :url="this.$API_URL + 'list/location_code'" :minLength="0" :params="{}"
                                        :disabled="!canEdit" />
                                    </FormField> -->

                                    <!-- <FormField :labelName="$t('department')" fieldName="Department" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Department" v-model="header.Department" type="text" :placeholder="$t('department')"  v-if="header" :disabled="!canEdit"  />
                                    </FormField> -->

                                    <FormField :labelName="$t('use_ad')" fieldName="Use_AD" v-model="header" labelClass="col-4" fieldClass="col-6 md-6" v-if="header && header.User_Type == this.$USER_LEVEL.WILMAR">
                                        <!-- <InputText name="Email" v-model="header.Email" type="text" :placeholder="$t('email')"  v-if="header" :disabled="mode == this.$FORM_MODE_VIEW"  /> -->
                                        <Checkbox v-model="header.Use_AD" :disabled="!canEdit || header.User_Type == this.$USER_LEVEL.WILMAR" v-if="header" :binary="true"/>
                                    </FormField>

                                    <!-- <FormField :labelName="$t('company')" fieldName="Company_Code" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="(header && header.User_Type != this.$USER_LEVEL.CONTRACTOR && !hidecompany)">
                                        <CustomSelect 
                                            class="p-inputtext-sm" 
                                            v-model="header.Company_Code" 
                                            :url="this.$API_URL + 'list/company_code'" 
                                            :minLength="0" 
                                            :params="{}" 
                                            v-if="header" 
                                            :disabled="mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || (header && header.Status == this.$APPROVAL_STATUS.APPROVED)"
                                            :filter="true"
                                            />
                                        <small v-if="header && !header.Company_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('company')) }}
                                        </small>
                                    </FormField> -->

                                    <FormField :labelName="$t('Contractor')" fieldName="Contractor_Code" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && header.User_Type == this.$USER_LEVEL.CONTRACTOR">
                                        <CustomSelect 
                                            class="p-inputtext-sm" 
                                            v-model="header.Contractor_Code" 
                                            :url="this.$API_URL + 'list/contractor_code'" 
                                            :minLength="0" 
                                            :params="{}" 
                                            v-if="header" 
                                            :disabled="mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE || (header && header.Status == this.$APPROVAL_STATUS.APPROVED)"
                                            :filter="true"
                                            />
                                        <small v-if="header && !header.Contractor_Code && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('Contractor')) }}
                                        </small>
                                    </FormField>

                                    <!-- <FormField :labelName="$t('job_position')" fieldName="Job_Position" v-model="header" labelClass="col-4" fieldClass="col-6">
                                        <CustomSelect 
                                            class="p-inputtext-sm" 
                                            v-model="header.Job_Position" 
                                            :url="this.$API_URL + 'list/lookup'" 
                                            :minLength="0" 
                                            :params="{ group : 'JOB_POSITION'}" 
                                            v-if="header" 
                                            :disabled="mode == $FORM_MODE_VIEW || mode == $FORM_MODE_DELETE"
                                            :filter="true"
                                            />
                                            <small
                                            v-if="header && !header.Job_Position && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('job_position')) }}
                                        </small>
                                    </FormField> -->

                                    <FormField v-if="header && header.User_Type != this.$USER_LEVEL.WILMAR" :labelName="$t('phone_number')" fieldName="Contact_Number" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Contact_Number" v-model="header.Contact_Number" type="text" :placeholder="$t('phone_number')"  v-if="header" :disabled="!canEdit"  />
                                        <small
                                            v-if="header && header.User_Type != this.$USER_LEVEL.WILMAR && !header.Contact_Number && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('phone_number')) }}
                                        </small>
                                    </FormField>
                                    <!-- isAdminProject -->
                                    <FormField v-if="mode != this.$FORM_MODE_CREATE && (header && header.Status == this.$APPROVAL_STATUS.APPROVED)" :labelName="$t('password')" fieldName="Use_AD" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <!-- <InputText name="Email" v-model="header.Email" type="text" :placeholder="$t('email')"  v-if="header" :disabled="mode == this.$FORM_MODE_VIEW"  /> -->
                                        <!-- <InputText type="password" v-model="header.Password" :disabled="!canEdit" v-if="header && header.Use_AD"/> -->
                                        <Button label="Reset Password" class="p-button-success" :disabled="!canEdit" v-if="header && !header.Use_AD" @click="confirmResetPass($event)" />
                                        <ConfirmPopup></ConfirmPopup>
                                    </FormField>

                                    <!-- <FormField labelName="Lock/Unlock Account" fieldName="Lock_Unlock" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <Button label="Lock/Unlock Account" class="p-button-warning" v-if="header" :disabled="!canEdit" @click="openDialog" />
                                    </FormField> -->

                                    <FormField :labelName="$t('all_company')" fieldName="All_Company" v-model="header" labelClass="col-4" fieldClass="col-6 md-6" v-if="header && header.User_Type != null && header.User_Type != this.$USER_LEVEL.CONTRACTOR">
                                        <Checkbox v-model="header.Company_All" :disabled="!canEdit" v-if="header" :binary="true" @change="onChangeAllCompany()"/>
                                    </FormField> 

                                    <FormField :labelName="$t('all_location')" fieldName="Location_All" v-model="header" labelClass="col-4" fieldClass="col-6 md-6" v-if="header && showLocationAll">
                                        <Checkbox v-model="header.Location_All" :disabled="!canEdit" v-if="header" :binary="true" @change="onChangeAllLocation()"/>
                                    </FormField> 
                                    
                                    <!-- isAdminProject -->
                                    <FormField :labelName="$t('active')" fieldName="Active" v-model="header" labelClass="col-4" fieldClass="col-6 md-6" v-if="header">
                                        <Checkbox v-model="header.Active" :disabled="!canEdit" v-if="header" :binary="true" @change="onChangeActive()"/>
                                    </FormField> 
                                    <FormField :labelName="$t('contact_person')" fieldName="Is_Contract_Person" v-model="header" labelClass="col-4" fieldClass="col-6 md-6" v-if="header">
                                        <Checkbox v-model="header.Is_Contract_Person" :disabled="!canEdit || header.User_Type != this.$USER_LEVEL.WILMAR || header.Department_Code != 'PROJECT'" :binary="true" @change="onChangeContractPerson()"/>
                                    </FormField> 

                                    <!-- <FormField :labelName="$t('all_department')" fieldName="All_Department" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <Checkbox v-model="header.Department_All" :disabled="!canEdit" v-if="header" :binary="true"/>
                                    </FormField> -->

                                </div>
                                <div class="col-6">
                                    <FormField :labelName="$t('status')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-6 md-6">
                                        <InputText name="Employee_Number" v-model="header.Status" type="text" :placeholder="$t('status')" 
                                        v-if="header" :disabled="true" v-on:blur="onBlur()"/>
                                    </FormField>
                                    <!-- <FormField :labelName="$t('digital_sign')" :fileModels="header.files_data" v-if="header" labelClass="col-4" fieldClass="col-6">
                                        <CustomFileUpload
                                            :fileModels="viewFiles"
                                            :multiple="true" 
                                            :showUploadButton="false" 
                                            :showCancelButton="false" 
                                            :customUpload="false" 
                                            @select="onFileSelect" 
                                            @remove="onFileRemove" 
                                            :viewOnly="true" 
                                            :showHeader="false"
                                            @download="onDownloadFile"
                                            />                                   
                                    </FormField>
                                
                                    <FormField :labelName="''" :fileModels="header.files_data" v-model="header" v-if="header" fieldClass="col-6" labelClass="col-4">
                                        <CustomFileUpload 
                                        :fileModels="header.files_data"
                                        :multiple="true" 
                                        :showUploadButton="false"
                                        :showCancelButton="false" 
                                        :customUpload="false" 
                                        accept="image/*"
                                        @select="onFileSelect($event, header)"
                                        :disabled="!canEdit"
                                        @remove="onFileRemove($event, header)" />
                                    </FormField> -->
                                    <FormField :labelName="$t('lock')" fieldName="Is_Lock" v-model="header" labelClass="col-4" fieldClass="col-6 md-6" v-if="header && isAdminProject">
                                        <Checkbox v-model="header.Is_Lock" :disabled="!canEdit" v-if="header" :binary="true" @change="onChangeLock()"/>
                                    </FormField> 

                                    <FormField :labelName="$t('reason')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-8 md-8" v-if="header && (header.Status == this.$APPROVAL_STATUS.APPROVED || header.Reason != null)">
                                        <InputText name="Reason" v-model="header.Reason" type="text" :placeholder="$t('reason')" 
                                        v-if="header" :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                        <small v-if="header && !header.Reason && submitted && mode != this.$FORM_MODE_DELETE"
                                            class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                        </small>
                                    </FormField>

                                </div>
                                <div class="col-6">
                                    <Groups :dataArray="header.Groups" :dataModel="groupModel" :mode="mode" v-if="header" :header="header" /> 
                                </div>
                                <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                                    <TabView>
                                        <TabPanel :header="$t('log_history')">
                                            <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                                :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                        </TabPanel>
                                        <TabPanel :header="$t('release_approval')">
                                            <ChangeHistory angeHistory v-if="this.header" :modelValue="this.dataModelRelease"
                                                :dataRequestLog="this.dataRelease" :mode="this.mode"></ChangeHistory>
                                        </TabPanel>
                                        <TabPanel :header="$t('Change_History')">
                                            <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                        </TabPanel>
                                    </TabView>
                                </div>  

                            </div>
                        </TabPanel>
                         <TabPanel :header="$t('company')" v-if="header && header.User_Type != null && header.User_Type != this.$USER_LEVEL.CONTRACTOR && !hidecompany">
                            <Companies :dataArray="header.Companies" :dataModel="companyModel" v-if="header" :header="header" :mode="mode" :location_code="this.header.Location_Code" />
                        </TabPanel>
                        <TabPanel :header="$t('location')" v-if="header && !hidelocation">
                            <Locations :dataArray="header.Locations" :dataModel="locationModel" v-if="header" :header="header" :mode="mode"/>
                        </TabPanel>

                        <!--<TabPanel :header="$t('department')">
                            <Department :dataArray="header.Departments" :dataModel="deparmentmodel" v-if="header" :header="header" :mode="mode"/>
                        </TabPanel> -->
                    </TabView>
                    
                </div>
            </template>
        </Card>
    
        <!-- <ChangePassword
            v-if="changePassword"
            :isVisible="changePassword"
            :userId="username"
            :requireCurrentPassword="true"
            @hide="hideChangePasswordDialog"
        /> -->

        <Dialog header="Lock/Unlock Account" v-model:visible="displayDialog" :closable="false" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '30vw'}">
			<div>
                <Message severity="warn" :closable="false">
                    {{ inactive_msg }} ({{ Is_Locked ? 'Locked' : 'Unlocked'}})
                </Message>
				<h6 id="single">Please select lock or unlock account</h6>
				<SelectButton v-model="Is_Locked" :options="lockOption" optionLabel="name" optionValue="value" aria-labelledby="single" />
			</div>
			<template #footer>
				<Button label="Cancel" icon="pi pi-times" @click="closeDialog" class="p-button-text"/>
				<Button label="Save" icon="pi pi-check" @click="saveLockUser" />
			</template> 
		</Dialog>
    
    </form>
</template>


<script>
    import Groups from './_Groups.vue';
    import Companies from './_Companies.vue';
    // import Department from './_Departments.vue';
    import Locations from './_Locations.vue';

    export default {
        name: "Editor",
        components: {
            Groups: Groups,
            Companies: Companies,
            // Department : Department,
            Locations: Locations
        },
        data() {
            return {
                indexName: "UserIndex",
                url: this.$API_URL + "user/",
                isHaveAD: this.$API_URL + "user/is_have_ad",
                resetPassUrl: this.$API_URL + "user/reset_password",
                header: null,
                detail: null,
                mode: "",
                id: 0,
                formEditable: true,
                groupModel:null,
                companyModel:null,
                businessSegmentModel: null,
                purchaseOrganizationModel: null,
                salesOrganizationModel: null,
                plantModel:null,
                distributionModel:null,
                locationModel:null,
                commodityGroupModel: null,
                changePassword:false,
                deparmentmodel : null,
                username: null,
                Is_Locked: null,
                lockOption: [
                    {name: 'Lock', value: true},
                    {name: 'Unlock', value: false},
                ],
                displayDialog:false,
                inactive_msg: '',
                submitted : false,
                viewFiles : null,
                dataModelReqLogs: [],
                dataRequestLogs: [
                    { field: "Action_Role", header: "Role" },
                    { field: "Action_By", header: "Action By" },
                    { field: "Action", header: "Action" },
                    { field: "Action_Date", header: "Action Date" },
                    { field: "Notes", header: "Notes" },
                ],
                dataModelRelease: [],
                detailLog : null,
                dataChangesLog:this.$dataChangesLogMasterData,
                dataRelease: [
                    { field: "Action_Role", header: "Role" },
                    { field: "Action_By", header: "Name" },
                    { field: "Level", header: "Level" },
                    { field: "Validity", header: "Validity" },
                    { field: "Status", header: "Status" }
                ],
                hidecompany : false,
                invalidEmail : false,
                isAdminProject : false,
                hidelocation : false,
            }
        },
        methods: {
            onChangeLock(){
                 if(this.header.Is_Lock)
                    this.header.action = "Lock";
                 else 
                    this.header.action = "Unlock";
            },
            onChangeUserType(e){
                if(e.id == this.$USER_LEVEL.WILMAR){
                    this.header.Use_AD = true;
                }
                else{
                    this.header.Use_AD = false;
                }

            },
            onChangeActive(){
                this.header.is_active = this.header.Active;
            },
            onChangeContractPerson(){
                this.header.Is_Contract_Person = this.header.Is_Contract_Person;
            },
            validateEmail() {
                //var self = this;
                this.invalidEmail = false;
                const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
                if (!emailRegex.test(this.header.Email)) {
                    //self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: "Invalid email format", life: 60000});
                    this.invalidEmail = true;
                    return true;
                } else {
                    //this.emailError = "";
                    this.invalidEmail = false;
                    return false;
                }
            },
            onBlur() {
                var self = this;
                this.$emit('block-ui');
                this.header.mode = this.mode

                this.$axios.post(this.isHaveAD, this.header)
                    .then((response) => {
                        if (response.data.message != "TRUE") {
                            this.header.Use_AD = false;
                            this.header.Full_Name = null;
                            this.header.Email = null;
                        }
                        else {
                            var data = response.data.data;
                            if(data.text)
                                data.text = data.text.toUpperCase();
                            if(data.email)
                                data.email = data.email.toUpperCase();
                            
                            this.header.Full_Name = data.text;
                            this.header.Email = data.email;
                            this.header.Use_AD = true;


                        }
                    })
                    .catch(function (error) {
                        alert(error);
                    });

                self.$emit('unblock-ui');
            },
            getData() {
                var self = this;
                this.$axios.get(this.url + this.id + "/" + this.mode)
                    .then((response) => {
                        self.header = response.data.data.header;
                        self.groupModel = response.data.data.group;
                        self.companyModel = response.data.data.company;
                        //self.businessSegmentModel = response.data.data.business_segment;
                        //self.plantModel = response.data.data.plant;
                        //self.distributionModel = response.data.data.distribution;
                        self.locationModel = response.data.data.location;
                        //self.commodityGroupModel = response.data.data.commodity_group;
                        //self.purchaseOrganizationModel = response.data.data.purchase_organization;
                        //self.salesOrganizationModel = response.data.data.sales_organization;                        
                        self.Is_Locked = response.data.data.header.Is_Blocked;
                        self.detailLog = self.header.DetailLog;
                        //self.deparmentmodel =  response.data.data.department;
                        self.dataModelReqLogs = response.data.data.header.request_log;
                        self.dataModelRelease = response.data.data.header.approval_log;
                        self.hidecompany = self.header.Company_All;
                        self.hidelocation = self.header.Location_All;
                        if(self.header.Status == this.$APPROVAL_STATUS.APPROVED) self.header.Reason = null;
                        if(self.mode == this.$FORM_MODE_CREATE) self.header.Location_All = false;
                        if(self.header.Digital_Sign){
                            var attachment = this.header.Digital_Sign.split(';');
                            self.viewFiles = [];
                            attachment.forEach(a => {
                                if (a != '') {
                                    var name = a.split("/").at(-1);
                                    var d = {
                                        name: name,
                                        // url: a,
                                        id: self.header.Id
                                    };

                                    self.viewFiles.push(d);
                                }
                            });
                        }
                    })
                    .catch(function (error) {
                    });
            },
            saveData() {
                var self = this;
                this.$emit('block-ui');
                var data = new FormData();
                
                if(this.header.files_data != null)
                    for(var x=0; x < this.header.files_data.length;x++){
                        var file = this.header.files_data[x];
                        data.append("attachments.File", file, file.name);
                }
                data.append("User_Type", this.header.User_Type);
                data.append("Id", this.header.Id);
                if(this.header.Employee_Number != null)
                    data.append("Employee_Number", this.header.Employee_Number);
                data.append("Full_Name", this.header.Full_Name);
                data.append("Company_Code", this.header.Company_Code != null ? this.header.Company_Code : null);
                data.append("Contractor_Code", this.header.Contractor_Code != null ? this.header.Contractor_Code : null);
                data.append("Use_Ad", this.header.Use_AD);
                data.append("Email", this.header.Email);
                if(this.header.Job_Position != null)
                    data.append("Job_Position", this.header.Job_Position);
                if(this.header.Location_Code != null)
                    data.append("Location_Code", this.header.Location_Code);
                data.append("Contact_Number", this.header.Contact_Number);
                data.append("mode", this.header.mode);
                if(this.header.Reason != null)
                    data.append("Reason", this.header.Reason);
                if(this.header.Company_All != null)
                    data.append("Company_All", this.header.Company_All);
                if(this.header.Location_All != null)
                    data.append("Location_All", this.header.Location_All);
                data.append("is_active", this.header.is_active);
                data.append("Active", this.header.Active);
                data.append(
                    "Is_Contract_Person",
                    this.header.Is_Contract_Person == null ? false : (this.header.Is_Contract_Person ? true: false)
                    );
                
                if(this.header.Department_Code)
                    data.append("Department_Code", this.header.Department_Code);
                if(this.header.Is_Lock != null)
                    data.append("Is_Lock", this.header.Is_Lock);

                if(this.header.action != null)
                    data.append("action", this.header.action);

            
                for(var i=0; i< this.header.Groups.length;i++){
                    var group = this.header.Groups[i];
                    if(group.mode != null)
                        data.append("Groups[" + i + "].mode", group.mode);
                    if(group.Group_Id != null)
                        data.append("Groups[" + i + "].Group_Id", group.Group_Id);
                    if(group.Id != null)
                        data.append("Groups[" + i + "].Id", group.Id);
                }


                for(var k=0; k< this.header.Companies.length;k++){
                    var comp = this.header.Companies[k];
                    if(comp.mode != null)
                        data.append("Companies[" + k + "].mode", comp.mode);
                    if(comp.Company_Id != null)
                        data.append("Companies[" + k + "].Company_Id", comp.Company_Id);
                    if(comp.Id != null)
                        data.append("Companies[" + k + "].Id", comp.Id);
                }

                for(var h=0; h< this.header.Locations.length;h++){
                    var loct = this.header.Locations[h];
                    if(loct.mode != null)
                        data.append("Locations[" + h + "].mode", loct.mode);
                    if(loct.Location_Id != null)
                        data.append("Locations[" + h + "].Location_Id", loct.Location_Id);
                    if(loct.Id != null)
                        data.append("Locations[" + h + "].Id", loct.Id);
                }
                this.$axios.post(this.url, data, 
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        if (response.data.success) {
                            self.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 120000} } );
                        }
                        else {
                            self.$emit('unblock-ui');
                            self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: response.data.message, life: 120000});
                        }
                    })
                    .catch(function (error) {
                        self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: error, life: 3000});
                        self.$emit('unblock-ui');
                    });
            },
            saveLockUser(){
                var self = this;
                var data = {
                    "user_id": this.header.Id,
                    "is_locked": this.Is_Locked
                };

                this.$emit('block-ui');
                this.$axios.post(this.$API_URL + "util/user_lock_unlock/", data)
                .then((response) => {
                    self.getData();
                    self.$emit('unblock-ui');
                    self.closeDialog();
                    if (response.data.success){
                        self.$toast.add({ severity: 'success', summary: 'Success Saving Data', detail: "User account has been saved successfully.", life: 50000});
                    }
                    else{
                        self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: response.data.error, life: 5000});
                    }
                })
                .catch(function (error) {
                    self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: error, life: 5000});
                    self.$emit('unblock-ui');
                });
            },
            resetPassword() {
                var self = this;
                this.$emit('block-ui');
                this.header.mode = this.mode

                this.$axios.post(this.resetPassUrl, this.header)
                    .then((response) => {
                        if (response.data.success) {
                            // self.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Password Reset', detail: response.data.message, life: 120000} } );
                            self.$toast.add({ severity: 'success', summary: 'Password Reset', detail: response.data.message, life: 120000 });
                            
                            // self.changePassword = true;
                            // this.username = this.header.Employee_Number;
                            
                            self.$emit('unblock-ui');
                        }
                        else {
                            self.$emit('unblock-ui');
                            self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: response.data.message, life: 120000});
                        }
                    })
                    .catch(function (error) {
                        self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: error, life: 3000});
                        self.$emit('unblock-ui');
                    });
            },
            // hideChangePasswordDialog(event){
            //     self = this;
            //     self.changePassword = false;
            //     // this.errormessage = "";

            //     if(event && event.success){
            //         // this.changePasswordSuccess = event.message;
            //         self.$toast.add({ severity: 'success', summary: 'Password Change', detail: event.message, life: 120000 });
            //     }
            // },
            backToIndex() {
                this.$router.push({ path: "/User/Index" });
            },
            toggle(event) {
                this.$refs.op.toggle(event);
            },
            confirm(event) {
                this.submitted= true;
                var self = this;
                debugger;
               // !this.header.Job_Position || (this.header.User_Type == this.$USER_LEVEL.WILMAR && !this.header.Company_Code) 
                             if(
                                        //(!this.header.Location_Code && this.header.Location_All == false) || 
                                        (this.header.User_Type != this.$USER_LEVEL.CONTRACTOR && this.header.User_Type != this.$USER_LEVEL.OUTSOURCING && !this.header.Employee_Number) || !this.header.Full_Name ||  !this.header.Email ||  !this.header.User_Type || 
                                    (this.header.User_Type != this.$USER_LEVEL.WILMAR && !this.header.Contact_Number) || (this.header.User_Type == this.$USER_LEVEL.CONTRACTOR && !this.header.Contractor_Code) || !this.header.Department_Code ||
                                    (this.header.Status == this.$APPROVAL_STATUS.APPROVED && !this.header.Reason))
                                        return false;

                if(this.invalidEmail){
                    self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: "Invalid email format", life: 60000});
                    return false;
                }

                // if(this.header.files_data == null && this.mode == this.$FORM_MODE_CREATE){
                //     self.showError("Error", "Must have attachment")
                //     return;
                // }   

                const activeGroups = this.header.Groups ? this.header.Groups.filter(g => g.mode !== this.$FORM_MODE_DELETE) : [];
                if(activeGroups.length == 0){
                    self.showError('Error Saving Data', "Must have at least one group");
                    return false;
                }
                const activeLocations = this.header.Locations ? this.header.Locations.filter(l => l.mode !== this.$FORM_MODE_DELETE) : [];
                if((activeLocations.length == 0) && this.header.Location_All == false){
                    self.showError('Error Saving Data', "Must have at least one location");
                    return false;
                }
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.header.mode = this.mode;
                        this.saveData();
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                    }
                });
            },
            confirmDraft(event) {
                this.submitted= true;
                var self = this;
                //!this.header.Job_Position || (this.header.User_Type == this.$USER_LEVEL.WILMAR && !this.header.Company_Code) 
                if(
                    //(!this.header.Location_Code && this.header.Location_All == false) || 
                    (this.header.User_Type != this.$USER_LEVEL.CONTRACTOR && this.header.User_Type != this.$USER_LEVEL.OUTSOURCING && !this.header.Employee_Number) || !this.header.Full_Name ||  !this.header.Email ||  !this.header.User_Type || 
                    !this.header.Department_Code || (this.header.User_Type != this.$USER_LEVEL.WILMAR && !this.header.Contact_Number) || (this.header.User_Type == this.$USER_LEVEL.CONTRACTOR && !this.header.Contractor_Code))
                    return false;
                
                if(this.invalidEmail){
                    self.$toast.add({ severity: 'error', summary: 'Error Saving Data', detail: "Invalid email format", life: 60000});
                    return false;
                }
                
                // if(this.header.files_data == null && this.mode == this.$FORM_MODE_CREATE){
                //     self.showError("Error", "Must have attachment")
                //     return;
                // }   

                const activeGroups = this.header.Groups ? this.header.Groups.filter(g => g.mode !== this.$FORM_MODE_DELETE) : [];
                if(activeGroups.length == 0){
                    self.showError('Error Saving Data', "Must have at least one group");
                    return false;
                }
                const activeLocations = this.header.Locations ? this.header.Locations.filter(l => l.mode !== this.$FORM_MODE_DELETE) : [];
                if((activeLocations.length == 0) && this.header.Location_All == false){
                    self.showError('Error Saving Data', "Must have at least one location");
                    return false;
                }

                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure save as draft?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        if(this.mode == this.$FORM_MODE_CREATE)
                            this.header.mode = this.$FORM_MODE_DRAFT;
                        else if(this.mode == this.$FORM_MODE_EDIT)
                            this.header.mode = this.$FORM_MODE_DRAFT_EDIT;
                        else
                            this.header.mode = this.mode;

                        this.saveData();
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                    }
                });
            },
            confirmResetPass(event) {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.resetPassword();
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                    }
                });
            },
            hideRow(data) {
                return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
            },
            openDialog(){
                this.inactiveMsg();
                this.displayDialog = true;
            },
            closeDialog(){
                this.displayDialog = false;
                this.Is_Locked = this.header.Is_Blocked;
            },
            inactiveMsg(){
                var userAccount = this.header;
                var lastAccessDate = new Date(this.$moment(userAccount.Last_Access_Date).format('L'));
                var currentDate = new Date(this.$moment(new Date()).format('L'));

                var lastDuration = currentDate.getTime() - lastAccessDate.getTime();
                var totalDays = lastDuration / (1000 * 3600 * 24);

                if(isNaN(totalDays)){
                    this.inactive_msg = "This account has never been active. ";
                }
                else{
                    this.inactive_msg = "This account has been inactive for "+totalDays+" days. ";
                }
            },
            onFileSelect(event, data) {
                data.files_data = [];
                for(var i = 0; i<event.files.length;i++){
                    data.files_data.push(event.files[i]);
                }
            },
            onFileRemove(files,data) {
                data.files_data = [];
                for(var i = 0; i<files.length;i++){
                    data.files_data.push(event.files[i]);
                }
            },
            onFileSelectUpload(event) {
                this.detailFiles = event.files;
                this.uploadFile = true;
            },
            onDownloadFile(file){
                var self = this;
                this.$axios.get(this.url + "download_attachment/" + file.id + "/" + file.name, {
                    responseType: 'blob',
                    timeout: this.$AXIOS_TIMEOUT_LONG
                    })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', file.name);
                        document.body.appendChild(link);
                        link.click();
                        
                    })
                    .catch(function (err) {
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    });
            },
            showError(summary, message) {
                this.$emit('unblock-ui');
                this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 120000});
            },
            onChangeAllCompany(){
                if(this.hidecompany == true)
                    this.hidecompany = false;
                else
                    this.hidecompany = true;

                this.header.Company_Code = null;
            },
            onChangeAllLocation(){
                if(this.hidelocation == true)
                    this.hidelocation = false;
                else
                    this.hidelocation = true;

                this.header.Location_Code = null;
            }
        },
        watch: {
            'header.User_Type'(newVal) {
                if (this.header && (this.header.User_Type != this.$USER_LEVEL.WILMAR || this.header.Department_Code != 'PROJECT')) {
                    this.header.Is_Contract_Person = false;
                }
            },
            'header.Department_Code'(newVal) {
                if (this.header && (this.header.User_Type != this.$USER_LEVEL.WILMAR || this.header.Department_Code != 'PROJECT')) {
                    this.header.Is_Contract_Person = false;
                }
            }
        },
        created() {
            this.mode = this.$route.query.mode;
            this.id = this.$route.query.id ?? 0;
            this.isAdminProject =this.$store.getters.getJobPosition.includes(this.$UserLevel.ADMIN_PROJECT) || this.$store.getters.getJobPosition.includes(this.$UserLevel.ADMIN_MASTER_DATA);
            this.getData();
        },
        computed:{
            canEdit(){
                return this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT;
            },
            showLocationAll() {
                return this.header?.Groups?.some(g => g.Administrator === true && g.mode !== this.$FORM_MODE_DELETE);
            },
            canSave(){
                return this.mode != this.$FORM_MODE_VIEW;
            },
            isOverNotAccess(){
                var duration = 90;
                var userAccount = this.header;
                var lastAccessDate = new Date(this.$moment(userAccount.Last_Access_Date).format('L'));
                var currentDate = new Date(this.$moment(new Date()).format('L'));

                if(userAccount.Last_Access_Date == null){
                    return true;
                }
                else{
                    var lastDuration = currentDate.getTime() - lastAccessDate.getTime();
                    var totalDays = lastDuration / (1000 * 3600 * 24);

                    if(totalDays >= duration){
                        return true;
                    }

                    return false;
                }
            }
        }
    }
</script>
